import script from "./coveringTheCity.vue?vue&type=script&setup=true&lang=js"
export * from "./coveringTheCity.vue?vue&type=script&setup=true&lang=js"

import "./coveringTheCity.vue?vue&type=style&index=0&id=3c3809e6&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3809e6"]])

export default __exports__